import { createFileRoute } from '@tanstack/react-router'
import { QcPlaygroundPage } from '@/features/qc'

export const Route = createFileRoute('/(app)/qc/')({
  component: QcPlaygroundPage,
})
